import { Controller } from "@hotwired/stimulus"

// Cmd/Ctrl + Enter submits the chat form.
export default class extends Controller {
  static targets = ["input"]

  maybeSubmit(event) {
    if ((event.metaKey || event.ctrlKey) && event.key === "Enter") {
      event.preventDefault()
      this.element.requestSubmit()
    }
  }
}
